"use client";
import { useEffect } from "react";
import { ButtonClickTrackingPlugin, enableButtonClickTracking, } from "@snowplow/browser-plugin-button-click-tracking";
import { ClientHintsPlugin } from "@snowplow/browser-plugin-client-hints";
import { EnhancedConsentPlugin } from "@snowplow/browser-plugin-enhanced-consent";
import { FormTrackingPlugin } from "@snowplow/browser-plugin-form-tracking";
import { LinkClickTrackingPlugin, enableLinkClickTracking, } from "@snowplow/browser-plugin-link-click-tracking";
import { PerformanceNavigationTimingPlugin } from "@snowplow/browser-plugin-performance-navigation-timing";
import { PerformanceTimingPlugin } from "@snowplow/browser-plugin-performance-timing";
import { newTracker } from "@snowplow/browser-tracker";
import { globalTrackerName } from "./config";
import { DefaultContextGenerator } from "./DefaultContextGenerator/DefaultContextGenerator";
import { LessonContextGenerator } from "./LessonContextGenerator/LessonContextGenerator";
import { OpportunityContextGenerator } from "./OpportunityContextGenerator/OpportunityContextGenerator";
import { TutorRequestContextGenerator } from "./TutorRequestContextGenerator/TutorRequestContextGenerator";
import { filterEvents } from "./utils";
/**
 * Initializes snowplow for your app with user context and optional button context.
 * @requires process.env.NEXT_PUBLIC_SNOWPLOW_COLLECTOR_URL setting in your env file
 */
export var Snowplow = function (props) {
    var appId = props.appId, clickEventContextMap = props.clickEventContextMap, isEnabled = props.isEnabled, snowplowCollectionUrl = props.snowplowCollectionUrl;
    useEffect(function () {
        if (!isEnabled)
            return;
        newTracker(globalTrackerName, snowplowCollectionUrl, {
            appId: appId,
            plugins: [
                FormTrackingPlugin(),
                PerformanceNavigationTimingPlugin(),
                PerformanceTimingPlugin(),
                ClientHintsPlugin(true),
                LinkClickTrackingPlugin(),
                ButtonClickTrackingPlugin(),
                EnhancedConsentPlugin(),
            ],
            cookieSameSite: "Lax",
            contexts: {
                webPage: true,
                session: true,
                browser: true,
            },
            discoverRootDomain: false,
        });
        var linkContexts = [
            new LessonContextGenerator().linkEnricher,
            new OpportunityContextGenerator().linkEnricher,
            new TutorRequestContextGenerator().linkEnricher,
        ];
        var buttonContexts = [
            new LessonContextGenerator().buttonEnricher,
            new OpportunityContextGenerator().buttonEnricher,
            new TutorRequestContextGenerator().buttonEnricher,
        ];
        var clickContextGenerator = clickEventContextMap && new DefaultContextGenerator(clickEventContextMap);
        if (clickContextGenerator) {
            linkContexts.push(clickContextGenerator.linkEnricher);
            buttonContexts.push(clickContextGenerator.buttonEnricher);
        }
        enableLinkClickTracking({
            context: linkContexts,
            trackContent: true,
            options: { filter: filterEvents },
        });
        enableButtonClickTracking({
            context: buttonContexts,
            filter: filterEvents,
        });
    }, [appId, clickEventContextMap, isEnabled, snowplowCollectionUrl]);
    return null;
};
